module.exports = __webpack_public_path__ + "img/logo-small.5c3e39e8.svg";